import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParcelsService} from '../../../services/settings-parcels.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'reminder-text-modal',
    templateUrl: './reminder-text-modal.component.html',
    styleUrls: ['./reminder-text-modal.component.scss']
})
export class ReminderTextModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    message = '';
    subject = '';
    originalMessage = '';
    originalSubject = '';
    placeholders = [
        '[[BUILDING_ADDRESS]]',
        '[[BUILDING_NAME]]',
        '[[UNIT_NUMBER]]',
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[DIRECTION]]',
        '[[RECEIVED_AT]]',
        '[[RECEIVED_BY]]',
        '[[PARCEL_TYPE]]',
        '[[NUMBER_OF_PIECES]]',
        '[[BAR_CODE]]',
        '[[DESCRIPTION]]',
        '[[EMAIL_TO_RESIDENT]]',
        '[[STATUS]]',
        '[[SIGNATURE]]',
        '[[PICKED_UP_AT]]',
        '[[PICKED_UP_BY]]',
        '[[MY_SIGNATURE]]',
        '[[PARCEL_ID]]',
        '[[COURIER]]',
        '[[INVITATION_LINK]]'
    ];
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public settingsParcelsService: SettingsParcelsService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.initData();
        setTimeout( () => this.initSummernote(false), 500);
        this.urlService.modalOpened.emit();
    }

    initData() {
        const setting = this.settingsParcelsService.selectedItemData;
        this.subject = setting.manualReminder.subject;
        this.message = setting.manualReminder.message;
        this.originalSubject = setting.manualReminder.subject;
        this.originalMessage = setting.manualReminder.message;
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'You want to delete unsaved data?'),
                () => {
                    this.settingsParcelsService.isShowReminderTextModal = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParcelsService.isShowReminderTextModal = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        const data = {
            manualReminder: {
                subject: this.subject,
                message: this.message
            }
        };

        this.disabledSubmit = true;
        const url = `/v1/parcel-service-settings/${this.settingsParcelsService.selectedItemData.corporationNumberBd}.json`;
        this.api.patch('domainParcels', url, data).subscribe(
            () => this.updateView('Reminder has been updated successfully', data),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Reminder has failed to update');
            }
        );
    }

    updateView(msg: string, data): void {
        toastr.success(msg);
        this.updateInfo(data);
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote(enabled) {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => this.message = contents
            },
            toolbar: enabled ? [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ] : [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });

        if(!enabled)
            summernote.summernote('disable');
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote(true), 300);
    }

    updateInfo(data) {
        this.settingsParcelsService.selectedItemData.manualReminder.subject = data.manualReminder.subject;
        this.settingsParcelsService.selectedItemData.manualReminder.message = data.manualReminder.message;
    }

    hideEditPanelSetter() {
        this.showEditPanel = false;
        setTimeout( () => this.initSummernote(false), 300);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/reminder-text-modal/reminder-text-modal.component.ts